import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { FaEye, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";
import Pagination from "../../views/Custom/Pagination";
import { tablesProjectData, tablesTableData } from "variables/general";
import useGetMyOrders from "../../hooks/useGetMyOrders";
import ViewPayment from "../../modals/ViewPayment";
import ViewOrder from "../../modals/ViewOrder";


function MyOrdersTable() {

    const [ page, setPage ] = useState(1);
    const pageLimit = 10;


    const { isOpen: isOpenViewOrder, onOpen: onOpenViewOrder, onClose: onCloseViewOrder } = useDisclosure();
    const { isOpen: isOpenViewPayment, onOpen: onOpenViewPayment, onClose: onCloseViewPayment } = useDisclosure();
    const [ orderData, setOrderData ] = useState(null);
    const [ viewPaymentId, setViewPaymentId ] = useState(null);
    
    let { 
      orders, 
      totalOrders, 
      setGettingOrders, 
      gettingOrders, 
      gettingOrdersReqSuccess 
    } = useGetMyOrders({page, limit: pageLimit });

    const textColor = useColorModeValue("gray.700", "white");

    useEffect(() => {
      setGettingOrders(true);
    }, []);
    

    return (
      <Flex direction="column" w="100%">
        {/* <Alert status="error" mb="4px"><AlertIcon></AlertIcon>
          Upcoming Payment Deadline for <AlertTitle>{'<Order ID>'}</AlertTitle> 
            is on <AlertTitle>{'<Day and Time>'}</AlertTitle>
        </Alert>
        <Alert status="error" mb="4px"><AlertIcon></AlertIcon>
          Upcoming Payment Deadline for <AlertTitle>{'<Order ID>'}</AlertTitle> 
            is on <AlertTitle>{'<Day and Time>'}</AlertTitle>
        </Alert> */}
        <Table variant="simple" color={textColor}>
          <Thead>
            <Tr my=".8rem" pl="0px" color="gray.400">
              <Th pl="0px" color="gray.400">Vehicle</Th>
              <Th pl="0px" color="gray.400">Paid/Total</Th>
              <Th pl="0px" color="gray.400">Payments</Th>
              <Th pl="0px" color="gray.400">Status</Th>
              <Th pl="0px" color="gray.400">Actions</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {gettingOrders ? 
              <Tr my=".8rem" >
                <Td minWidth={{ sm: "250px" }} pl="0px" colSpan={4}>
                  <Progress isIndeterminate />
                </Td>
              </Tr>
              : orders.map((o) => {
                return (
                  <Tr my=".8rem" pl="0px">
                    <Td  pl="0px">
                      <Text>{o.carMake} {o.carType} {o.carYear}</Text>
                      <Text>{o.carPlate} {o.carOdometer}</Text>
                    </Td>
                    <Td  pl="0px">
                      ₱{Number(o.paymentsTotal).toLocaleString()}/₱{Number(o.total).toLocaleString()}
                    </Td>
                    <Td  pl="0px">
                      { o.payments.map((p, pIndex) => {
                          return <Text 
                              key={`payment-view-${pIndex}`}
                              p="0px" bg="transparent" 
                              title="View Payment Details"
                              onClick={() => {
                                // console.log(p);
                                setOrderData(o);
                                setViewPaymentId(p.id);
                                onOpenViewPayment(true);
                              }}
                            >
                            <Flex direction="column" cursor="pointer" align="start">
                              <Text  as="u" textColor={"blue"}>₱{Number(p.amount).toLocaleString()}</Text>
                            </Flex>
                          </Text>
                        })
                      }
                    </Td>
                    <Td  pl="0px">
                      {o.completed 
                            ? <Text color={'green'}>Complete</Text>
                            : <Text color={'orange  '}>Ongoing</Text>}
                    </Td>
                    <Td  pl="0px">
                      <Button 
                        p="0px" 
                        bg="transparent" 
                        onClick={() => {
                          setOrderData(o);
                          onOpenViewOrder(true);
                        }}>
                        <Flex color={textColor} cursor="pointer" align="center" p="12px">
                          <Icon as={FaEye} me="4px" />
                          <Text fontSize="sm" fontWeight="semibold">
                            View Details
                          </Text>
                        </Flex>
                      </Button>
                    </Td>
                  </Tr>
                );
              })
            }
          </Tbody>
        </Table>
        { totalOrders != 0
            ? <Pagination 
              totalItems={totalOrders}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
            : null
          }


        <ViewOrder 
            isOpen={isOpenViewOrder}
            onClose={onCloseViewOrder}
            orderData={orderData}
        />
        <ViewPayment 
            isOpen={isOpenViewPayment}
            onClose={onCloseViewPayment}
            orderData={orderData}
            paymentId={viewPaymentId}
        />
      </Flex>
    )
}


export default MyOrdersTable;